import apiClient from './client';
import { API_PATHS } from './paths';
import type { ApiResponse } from '../types/api';
import type { Business } from '../types/client';

export const clientBusinessApi = {
  get: async (): Promise<Business> => {
    const res = await apiClient.get<ApiResponse<Business>>(API_PATHS.CLIENT_BUSINESS);
    return res.data.data;
  },
};
